import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const styles = {
    filterButton: {
        background: colors.primaryDark,
        border: 'none',
        borderRadius: '5px',
        color: colors.white,
        cursor: 'pointer',
        padding: '4px 8px',
    },
    filterButtonX: {
        marginTop: '1px',
    },
};

export const FilterChip = ({ label, value, buttonClasses, attribute, onClick }) => {
    // e.g. Architecture/Design/Engineering > ARC04-Graphic Design
    const parts = label.split(' > ');
    let finalLabel = '';

    if (parts.length === 1) {
        finalLabel = parts[0];
    } else {
        // ARC04-Graphic Design - remove code
        const childLabelParts = parts[1].split('-');
        const childLabel = childLabelParts.length === 1 ? childLabelParts[0] : childLabelParts[1];
        finalLabel = `${parts[0]} > ${childLabel}`;
    }

    if (attribute === 'company_name') {
        finalLabel = `Company: ${finalLabel}`;
    } else if (attribute === 'minority_owned') {
        finalLabel = 'Minority Owned';
    } else if (attribute === 'woman_owned') {
        finalLabel = 'Woman Owned';
    }

    return (
        <li className="d-inline-block mr-2 mb-2">
            <button
                type="button"
                className={`d-flex align-items-top ${buttonClasses}`}
                style={styles.filterButton}
                onClick={() => onClick(value)}
            >
                <span style={styles.filterButtonX}>
                    <FontAwesomeIcon icon={faTimes} />
                </span>
                <span className="ml-2 text-left">{finalLabel}</span>
            </button>
        </li>
    );
};

FilterChip.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    buttonClasses: PropTypes.string,
    attribute: PropTypes.string,
    onClick: PropTypes.func,
};
